export const getTargetRect = (target) => {
  if (!target) {
    return
  }
  return target !== window
    ? target.getBoundingClientRect()
    : {
        bottom: window.innerHeight,
        height: window.innerHeight,
        left: 0,
        right: 0,
        top: 0,
        width: window.innerWidth
      }
}

function cached(fn) {
  const cache = Object.create(null)

  return function cachedFn(str) {
    const hit = cache[str]
    return hit || (cache[str] = fn(str))
  }
}
const camelize = cached(function (str) {
  return str.replace(/-(\w)/g, function (matchStr, replaceStr, indexOfSource, sourceStr) {
    return replaceStr ? replaceStr.toUpperCase() : ''
  })
})
export function isScroll(el, isVertical) {
  const key = {
    undefined: 'overflow',
    true: 'overflow-y',
    false: 'overflow-x'
  }
  const overflow = getStyle(el, key[isVertical])
  return ['scroll', 'auto', 'overlay'].some((s) => overflow.includes(s))
}
export function getScrollContainer(el, isVertical) {
  let parent = el
  while (parent) {
    if ([window, document, document.documentElement].includes(parent)) {
      return window
    }
    if (isScroll(parent, isVertical)) return parent
    parent = parent.parentNode
  }
  return parent
}
export function getStyle(element, styleName) {
  if (!element || !styleName) return ''

  let key = camelize(styleName)
  if (key === 'float') key = 'cssFloat'
  try {
    const style = element.style[key]
    if (style) return style
    const computed = document.defaultView.getComputedStyle(element, '')
    return computed ? computed[key] : ''
  } catch {
    return element.style[key]
  }
}
export const getOffsetTop = (dom, distance) => {
  distance = distance || 0
  if (['BODY', null].includes(dom.offsetParent.nodeName)) {
    distance += dom.offsetTop
    return distance
  } else {
    distance += dom.offsetTop
    return getOffsetTop(dom.offsetParent, distance)
  }
}
export const getDistance = (obj) => {
  let left = 0
  let top = 0
  while (obj) {
    left += obj.offsetLeft
    top += obj.offsetTop
    obj = obj.offsetParent
  }
  return {
    left,
    top
  }
}
export const on = (function () {
  if (document.addEventListener) {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.addEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event && handler) {
        element.attachEvent('on' + event, handler)
      }
    }
  }
})()

/* istanbul ignore next */
export const off = (function () {
  if (document.removeEventListener) {
    return function (element, event, handler) {
      if (element && event) {
        element.removeEventListener(event, handler, false)
      }
    }
  } else {
    return function (element, event, handler) {
      if (element && event) {
        element.detachEvent('on' + event, handler)
      }
    }
  }
})()
export const isInContainer = (el, container) => {
  if (!el || !container) return false

  const elRect = el.getBoundingClientRect()
  let containerRect

  if ([window, document, document.documentElement, null, undefined].includes(container)) {
    containerRect = {
      top: 0,
      right: window.innerWidth,
      bottom: window.innerHeight,
      left: 0
    }
  } else {
    containerRect = container.getBoundingClientRect()
  }

  return (
    elRect.top < containerRect.bottom &&
    elRect.bottom > containerRect.top &&
    elRect.right > containerRect.left &&
    elRect.left < containerRect.right
  )
}
